/* eslint-disable */
import productCollectionAPI from "./data";

const state = {
  list: [],
  edit: null,
  status_choices: ['public', 'private', 'archived', 'draft']
};

// getters
const getters = {
  loading(state) {
    return state.loadingCount === 0;
  }
};

// actions
const actions = {
  init: (context, refresh = false) => {
    if (!!context.state.list["results"] && !refresh) {
      return context.state.list;
    }
    return productCollectionAPI.list(context).then(data => {
      context.commit("SET_LIST", data.results);
    });
  },
  update: (context, productCollection, continueEdit = false) => {
    return productCollectionAPI.update(context, productCollection).then(data => {
      context.dispatch("init", true);
      if (continueEdit) {
        context.commit("SET_EDIT", data);
      } else {
        context.commit("SET_EDIT", null);
      }
      return data;
    });
  },
  insert: (context, productCollection) => {
    return productCollectionAPI.insert(context, productCollection).then(data => {
      context.dispatch("init", true);
      return data;
    });
  },
  get: (context, productCollectionKey) => {
    context.commit("SET_LOADING", true);
    return productCollectionAPI.get(context, productCollectionKey).then(data => {
      context.commit("SET_EDIT", data);
      return data;
    });
  }
};

// mutations
const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
